import * as Yup from 'yup';

// Defaults
export const formValues = {
    wasteCode: '',
    wasteName: '',
    wasteCategory: '',
    yCode: '',
    weight: '',
    loadingCode: '',
    companyName: '',
    acronym: ''
}

export const validation = () => (
    Yup.object({
        
    })
)